import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { heSoLopTuNguyenApi } from "../../../api/thiet-lap/heSoLopTuNguyenApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IAccHeSoLopTuNguyen } from "../../../model/respone/thiet-lap/IAccHeSoLopTuNguyen";
import { IHeSoLopTuNguyenActionTypes } from "../../action-types/thiet-lap/IHeSoLopTuNguyenActionTypes";
import { rootActions } from "../../actions/rootActions";
import { eHeSoLopTuNguyenActionIds } from "./../../action-types/thiet-lap/IHeSoLopTuNguyenActionTypes";

export function* heSoLopTuNguyenSaga(): any {
  yield takeLatest(eHeSoLopTuNguyenActionIds.LOAD_LOP_START, loadLopWorker);
  yield takeLatest(eHeSoLopTuNguyenActionIds.LOAD_HESO_START, loadHeSoWorker);
  yield takeEvery(eHeSoLopTuNguyenActionIds.SAVE_HESO_START, saveWorker);
  yield takeEvery(eHeSoLopTuNguyenActionIds.DELETE_HESO_START, deleteWorker);
  yield takeLatest(eHeSoLopTuNguyenActionIds.SYNC_START, syncWorker);
  yield takeLatest(
    eHeSoLopTuNguyenActionIds.SAVE_HESO_LOP_START,
    saveHeSoLopWorker
  );
}

function* loadLopWorker(action: IHeSoLopTuNguyenActionTypes): any {
  const res: IBaseRespone = yield call(
    heSoLopTuNguyenApi.SelectLopTuNguyen,
    action.payload
  );
  if (res.is_success) {
    yield put(rootActions.thietLap.heSoLopTuNguyen.LOAD_LOP_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.thietLap.heSoLopTuNguyen.LOAD_LOP_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* loadHeSoWorker(action: IHeSoLopTuNguyenActionTypes): any {
  const res: IBaseRespone = yield call(
    heSoLopTuNguyenApi.SelectHeSo,
    action.payload as any
  );
  if (res.is_success) {
    yield put(rootActions.thietLap.heSoLopTuNguyen.LOAD_HESO_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.thietLap.heSoLopTuNguyen.LOAD_HESO_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* saveWorker(action: IHeSoLopTuNguyenActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IAccHeSoLopTuNguyen;
  if (payload.id > 0) {
    res = yield call(heSoLopTuNguyenApi.Update, payload);
  } else {
    res = yield call(heSoLopTuNguyenApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(
        rootActions.thietLap.heSoLopTuNguyen.SAVE_HESO_SUCCESS(res.data)
      );
    } else {
      yield put(
        rootActions.thietLap.heSoLopTuNguyen.SAVE_HESO_ERROR(
          res.message ?? "Có lỗi"
        )
      );
    }
  }
}

function* deleteWorker(action: IHeSoLopTuNguyenActionTypes): any {
  const res: IBaseRespone = yield call(
    heSoLopTuNguyenApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(
      rootActions.thietLap.heSoLopTuNguyen.DELETE_HESO_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.thietLap.heSoLopTuNguyen.DELETE_HESO_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* syncWorker(action: IHeSoLopTuNguyenActionTypes): any {
  const res: IBaseRespone = yield call(heSoLopTuNguyenApi.Sync, action.payload);
  if (res.is_success) {
    yield put(rootActions.thietLap.heSoLopTuNguyen.SYNC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.thietLap.heSoLopTuNguyen.SYNC_ERR(res.message ?? "Có lỗi")
    );
  }
}

function* saveHeSoLopWorker(action: IHeSoLopTuNguyenActionTypes): any {
  const res: IBaseRespone = yield call(
    heSoLopTuNguyenApi.UpdateHoLopTuNguyen,
    action.payload
  );
  if (res.is_success) {
    yield put(
      rootActions.thietLap.heSoLopTuNguyen.SAVE_HESO_LOP_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.thietLap.heSoLopTuNguyen.SAVE_HESO_LOP_ERR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
